/**
 * Route /transaction/withdraw_history — same real data & UI as withdrawal list.
 */
export { default } from "./SucWithdraw";
